/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/dataReportManage',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '自营-数据报表',
      icon: 'component',
    },
    children: [
      {
        path: '/dataReportManage/salesdata',
        component: () => import('@/myviews/shoppMall/dataReportManage/salesdata/salesdataList.vue'),
        alwaysShow: false,
        name: 'salesdata',
        meta: {
          title: '销售数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/flowsdata',
        component: () => import('@/myviews/shoppMall/dataReportManage/flowsdata/flowsdataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'flowsdata',
        meta: {
          title: '流量数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/spreaddata',
        component: () => import('@/myviews/shoppMall/dataReportManage/spreaddata/spreaddataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'spreaddata',
        meta: {
          title: '推广数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/addata',
        component: () => import('@/myviews/shoppMall/dataReportManage/addata/addataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'addata',
        meta: {
          title: '广告位数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/distributiondata',
        component: () => import('@/myviews/shoppMall/dataReportManage/distributiondata/distributiondataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'distributiondata',
        meta: {
          title: '分销数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/searchdata',
        component: () => import('@/myviews/shoppMall/dataReportManage/searchdata/searchdataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'searchdata',
        meta: {
          title: '搜索数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/columndata',
        component: () => import('@/myviews/shoppMall/dataReportManage/columndata/columndataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'columndata',
        meta: {
          title: '首页栏目位数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/floordata',
        component: () => import('@/myviews/shoppMall/dataReportManage/floordata/floordataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'floordata',
        meta: {
          title: '首页楼层位数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/repurchaseData',
        component: () => import('@/myviews/shoppMall/dataReportManage/repurchaseData/repurchaseDataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'repurchaseData',
        meta: {
          title: '复购数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataReportManage/aixiaogudata',
        component: () => import('@/myviews/shoppMall/dataReportManage/aixiaogudata/aixiaogudataList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'aixiaogudata',
        meta: {
          title: 'AI数据报表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/dataReportManage.js